import { CheckBoxWidget } from '@tableau/widgets';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '../../../../codegen/Localize';
import { ExplorerStyles } from '../../../components/Explorer/ExplorerStyles';

export interface ICheckboxCellOptions {
  onCheckboxClicked: (row: DataGrid.Row) => void;
  checkboxCellTestIdFn: (row: DataGrid.Row) => string;
  isRowSelected: (row: DataGrid.Row) => boolean;
  isRowDisabled: (row: DataGrid.Row) => boolean;
}

export function CheckboxCell(options: ICheckboxCellOptions): React.Factory<BodyCell.Props> {
  return React.createFactory(class extends React.Component<BodyCell.Props, any> {
    displayName: 'CheckboxCell';

    boundHandleClick = this.handleClick.bind(this);

    handleClick(event: React.MouseEvent<HTMLSpanElement>) {
      const props: BodyCell.Props = this.props;
      options.onCheckboxClicked(props.row);
      event.preventDefault();
      event.stopPropagation();
    }

    render() {
      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        <span
          onClick={this.boundHandleClick}
          className={options.isRowDisabled(this.props.row) ? ExplorerStyles.CheckboxCellContainerDisabled : ExplorerStyles.CheckboxCellContainer}
          title={Messages.listViewCheckbox()}
        >
          <CheckBoxWidget
            testId={options.checkboxCellTestIdFn(this.props.row)}
            checked={options.isRowSelected(this.props.row)}
            tabIndex={-1} // disable tabbing in datagrid cells, leaving focus managed by datagrid itself
            aria-label={'checkbox'}
          />
        </span>
      );
    }
  });
}
